import { Map } from "immutable"
import { Observable } from "rxjs/Observable"

import {
    getList,
    getItem,
    postItem,
    putItem,
    deleteItem
} from "./utils/entity-network-requests"
import { getURLSearchParams, getAuthHeader } from "./utils/network-config"

const entityName = "map"

export const getMapList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getMapItem = (token, id) =>
    getItem(entityName, id, token, Map({ related_statuses: "Active" }))
export const getMapBriefing = (token, id) => {
    const headers = {
        Accept: "application/pdf"
    }
    return Observable.ajax({
        url: `${process.env
            .REACT_APP_DASHBOARD_URI}/topic/${id}/briefing?token=${token}`,
        method: "GET",
        responseType: "blob",
        headers
    })
}
export const putMapItem = (token, id, entity) =>
    putItem(entityName, id, entity, token)
export const postMapItem = (token, entity) =>
    postItem(entityName, entity, token)
export const deleteMapItem = (token, id) => deleteItem(entityName, id, token)
export const sendMapBriefingEmail = (token, id, briefingEmail) =>
    postItem(`topic/briefing/${id}`, briefingEmail, token)

// image
export const getMapImage = (token, id, queryParams) => {
    const headers = {
        Accept: "image/png",
        ...getAuthHeader(token)
    }
    const serializedQueryParams = getURLSearchParams(queryParams).toString()

    return Observable.ajax({
        url: `${process.env
            .REACT_APP_DASHBOARD_URI}/image-generator/topic/${id}/image?${serializedQueryParams}`,
        method: "GET",
        responseType: "blob",
        headers
    })
}
